import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, ChevronDown } from 'lucide-react';
export function GuaranteeSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito experiencia previa en carpintería?',
    a: 'No. El sistema está diseñado desde cero. Si ya tenés experiencia, te va a servir para optimizar tus procesos y ganar más plata. Si recién empezás, te va a ahorrar años de errores caros.'
  }, {
    q: '¿Cómo recibo el material después de comprar?',
    a: 'El acceso es automático e inmediato. Una vez que se aprueba el pago en Mercado Pago, te llega un mail con el link para descargar todos los tomos y bonos en formato PDF de alta calidad.'
  }, {
    q: '¿Sirve para todas las provincias de Argentina?',
    a: 'Sí, 100%. Las medidas, perfiles y catálogos que usamos son los estándar que se consiguen en cualquier distribuidora de aluminio del país (Aluar, MD, etc).'
  }, {
    q: '¿Qué pasa si los precios cambian por la inflación?',
    a: 'El sistema te enseña a presupuestar por coeficiente y porcentajes, no por precios fijos. Así que no importa si el aluminio aumenta mañana, tu fórmula de cálculo siempre va a ser exacta.'
  }, {
    q: '¿Puedo pagar en cuotas?',
    a: 'Sí, podés pagar hasta en 12 cuotas con cualquier tarjeta de crédito a través de Mercado Pago. También aceptamos débito y dinero en cuenta.'
  }];
  return <section className="bg-[#1B3A5C] py-14 px-4" data-id="element-104">
      <div className="container mx-auto max-w-4xl" data-id="element-105">
        {/* Guarantee Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-white rounded-3xl p-8 md:p-12 text-center mb-20 shadow-2xl relative" data-id="element-106">
          <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-[#D4A017] w-24 h-24 rounded-full flex items-center justify-center shadow-xl border-4 border-white" data-id="element-107">
            <ShieldCheck className="w-12 h-12 text-white" data-id="element-108" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-black mt-8 mb-4" data-id="element-109">
            Riesgo CERO para vos
          </h2>
          <h3 className="text-xl font-bold text-[#1B3A5C] mb-6 uppercase tracking-wider" data-id="element-110">
            GARANTÍA TOTAL 7 DÍAS
          </h3>

          <p className="text-gray-700 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-111">
            Estoy tan seguro de que este sistema va a cambiar tu forma de
            trabajar, que asumo todo el riesgo. Comprá el Super Combo hoy,
            leelo, aplicalo. Si en los próximos 7 días sentís que no vale cada
            centavo que pagaste, me mandás un mail y te devuelvo el 100% de tu
            plata. Sin preguntas. Sin vueltas.
          </p>
        </motion.div>

        {/* FAQ Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} data-id="element-112">
          <h2 className="text-3xl font-bold text-white text-center mb-10" data-id="element-113">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-114">
            {faqs.map((faq, index) => <div key={index} className="bg-[#152c46] border border-white/10 rounded-xl overflow-hidden" data-id="element-115">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-116">
                  <span className="text-white font-medium text-lg pr-4" data-id="element-117">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-[#D4A017] transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-118" />
                </button>

                <AnimatePresence data-id="element-119">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-120">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-white/5 mt-2" data-id="element-121">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}